module.exports = __webpack_public_path__ + "img/hollow_clock_12.4278f5ab.svg";